import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { logging } from "../creator/utils/logging";


export class gameFindFive extends cDisplay {

  private curScreen: cInlineDisplay
  private curSelected: any;x
  private items:any[]

  private keys:any = {}

  init(){
    super.init()
    logging.log('INIT FIND FIVER 1');

    var cS:cScene = this.scene as cScene;
    var canvas = cS.sys.game.canvas;
    var canvasWidth = Number( String(canvas.style.width).replace('px','') );

    var hiFX = 1080 / window.innerHeight;
    var fw   = Math.min(window.innerWidth,canvasWidth) * hiFX;

    this.curSelected = null;

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'slideBack':
          var xLeft = -(fw/4)-(1920/2)
          var xRight = (fw/4)-(1920/2)+8

          var $this = this;        
          this.scene.tweens.add({
            targets:[ this.getByName('bg_a')],
            x: xLeft,            
            alpha:1,
            duration:1200
          });
          this.scene.tweens.add({
            targets:[ this.getByName('bg_b')],
            x: xRight,            
            alpha:1,
            duration:1200,
            onComplete:()=>{
              $this.getByName('btn_holder').x = xRight
            }
          });
          break;
        case 'itemClick':
          var btn = this.getByName('btn_'+b.payload.btn)
          if (!btn) { console.error('BTN NOT FOUND')}

          var circle = this.getByName('circle_'+b.payload.btn)
          if (!circle) { console.error('BTN NOT FOUND')}

          btn.visible = false
          circle.visible = true

          this.keys[b.payload.btn] = 'ok'

          if ( Object.keys(this.keys).length === 5 ){
            cS.triggerSceneEvent('completed',{value:-1});
          }
          this.blinkInFive();
          break;
      }
    })
  }

  buildScene(){    
    super.buildScene();
    this.blinkInFive();
  }

  private DD;
  blinkInFive(){
    if (this.DD){
      clearTimeout(this.DD);
    }
    var $this=this;
    this.DD = setTimeout( ()=>{

      var items = ['circle_1','circle_2','circle_3','circle_4','circle_5'].filter((itm)=>!this.getByName(itm).visible);
      items.forEach((itm)=>this.getByName(itm).visible = true)
      setTimeout(()=>{
        items.forEach((itm)=>this.getByName(itm).visible = false)
        this.blinkInFive();
      },100);

    },15000);
  }


}
